import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function TermsAndConditions() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('terms');
  const [expandedSections, setExpandedSections] = useState({
    terms: Array(8).fill(true),
    privacy: Array(8).fill(true)
  });

  const toggleSection = (tab, index) => {
    const newExpandedSections = { ...expandedSections };
    newExpandedSections[tab][index] = !newExpandedSections[tab][index];
    setExpandedSections(newExpandedSections);
  };

  // CSS styles embedded directly in the component
  const styles = {
    backArrow: {
      position: 'absolute',
      top: '20px',
      left: '20px',
      fontSize: '24px',
      color: 'white',
      cursor: 'pointer',
      backgroundColor: 'rgba(255, 255, 255, 0.2)',
      width: '40px',
      height: '40px',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      transition: 'background-color 0.2s',
    },
    container: {
      maxWidth: '900px',
      margin: '20px auto',
      backgroundColor: '#fff',
      borderRadius: '10px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
    },
    header: {
      background: 'linear-gradient(to right, #3b82f6, #4f46e5)',
      padding: '20px',
      color: 'white',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    headerH1: {
      fontSize: '24px',
      fontWeight: 'bold',
    },
    date: {
      fontSize: '14px',
    },
    tabs: {
      display: 'flex',
      borderBottom: '1px solid #e5e7eb',
      textAlign: 'left',
    },
    tab: {
      flex: 1,
      padding: '15px',
      textAlign: 'center',
      cursor: 'pointer',
      fontWeight: 500,
      background: 'none',
      border: 'none',
      outline: 'none',
      color: '#6b7280',
    },
    activeTab: {
      color: '#3b82f6',
      borderBottom: '2px solid #3b82f6',
    },
    content: {
      padding: '20px',
      textAlign: 'left',
    },
    tabContent: {
      display: 'none',
    },
    activeContent: {
      display: 'block',
    },
    titleContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '20px',
    },
    checkIcon: {
      color: '#10b981',
      marginRight: '10px',
      fontSize: '24px',
    },
    contentH2: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#1f2937',
    },
    intro: {
      marginBottom: '20px',
      color: '#4b5563',
    },
    section: {
      borderBottom: '1px solid #e5e7eb',
      padding: '12px 0',
    },
    sectionHeader: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      cursor: 'pointer',
      padding: '5px 0',
    },
    sectionH3: {
      fontSize: '18px',
      fontWeight: 600,
      color: '#1f2937',
    },
    chevron: {
      transition: 'transform 0.2s',
    },
    sectionContent: {
      margin: '10px 0',
      color: '#4b5563',
    },
    hiddenContent: {
      display: 'none',
    },
    ul: {
      listStyleType: 'disc',
      marginLeft: '25px',
      marginTop: '10px',
    },
    li: {
      marginBottom: '5px',
    },
    additionalInfo: {
      marginTop: '10px',
    },
    footer: {
      backgroundColor: '#f3f4f6',
      padding: '15px 20px',
      textAlign: 'center',
      fontSize: '14px',
      color: '#6b7280',
    },
    contactInfo: {
      marginTop: '10px',
    },
    contactInfoP: {
      margin: '2px 0',
    },
    companyName: {
      fontWeight: 'bold',
    },
    email: {
      marginTop: '10px',
    },
    contactInfoA: {
      color: '#3b82f6',
      textDecoration: 'none',
    },
  };

  // Apply media query styles conditionally
  if (window.innerWidth <= 640) {
    styles.container = {
      ...styles.container,
      margin: '10px',
      borderRadius: '5px',
    };
    styles.header = {
      ...styles.header,
      flexDirection: 'column',
      alignItems: 'flex-start',
      paddingTop: '40px', // Add space for the back arrow
    };
    styles.date = {
      ...styles.date,
      marginTop: '5px',
    };
    styles.backArrow = {
      ...styles.backArrow,
      top: '10px',
      left: '10px',
    };
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div 
          style={styles.backArrow} 
          onClick={() => navigate('/')}
          title="Back to Home"
        >
          ←
        </div>
        <h1 style={styles.headerH1}>Apex Advisors</h1>
        <div style={styles.date}>Effective Date: 19th May 2025</div>
      </div>

      {/* Tab Navigation */}
      <div style={styles.tabs}>
        <button 
          style={{...styles.tab, ...(activeTab === 'terms' ? styles.activeTab : {})}}
          onClick={() => setActiveTab('terms')}
        >
          Terms & Conditions
        </button>
        <button 
          style={{...styles.tab, ...(activeTab === 'privacy' ? styles.activeTab : {})}}
          onClick={() => setActiveTab('privacy')}
        >
          Privacy Policy
        </button>
      </div>

      {/* Content Area */}
      <div style={styles.content}>
        {/* Terms & Conditions */}
        <div style={{
          ...styles.tabContent,
          ...(activeTab === 'terms' ? styles.activeContent : {})
        }}>
          <div style={styles.titleContainer}>
            <span style={styles.checkIcon}>✓</span>
            <h2 style={styles.contentH2}>Terms and Conditions</h2>
          </div>
          <p style={styles.intro}>
            Welcome to Apex Advisors. By using our website and services, you agree to be bound by the following Terms and Conditions. Please read them carefully.
          </p>
          
          {/* Terms Sections */}
          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 0)}>
              <h3 style={styles.sectionH3}>1. Services Offered</h3>
              <span style={styles.chevron}>{expandedSections.terms[0] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[0] ? {} : styles.hiddenContent)
            }}>
              <ul style={styles.ul}>
                <li style={styles.li}>Study abroad guidance for the USA, UK, Canada, Australia, and Europe</li>
                <li style={styles.li}>Admission and student visa assistance</li>
                <li style={styles.li}>In-house coaching for Duolingo and IELTS</li>
                <li style={styles.li}>Interview preparation</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 1)}>
              <h3 style={styles.sectionH3}>2. Eligibility</h3>
              <span style={styles.chevron}>{expandedSections.terms[1] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[1] ? {} : styles.hiddenContent)
            }}>
              <p>
                You must be at least 16 years of age to use our services. If you are under 18, you must use our services with the involvement of a parent or guardian.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 2)}>
              <h3 style={styles.sectionH3}>3. User Responsibilities</h3>
              <span style={styles.chevron}>{expandedSections.terms[2] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[2] ? {} : styles.hiddenContent)
            }}>
              <ul style={styles.ul}>
                <li style={styles.li}>Provide accurate and complete information.</li>
                <li style={styles.li}>Do not misuse or attempt to harm the website or services.</li>
                <li style={styles.li}>Respect copyright and proprietary content.</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 3)}>
              <h3 style={styles.sectionH3}>4. Payment & Refund Policy</h3>
              <span style={styles.chevron}>{expandedSections.terms[3] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[3] ? {} : styles.hiddenContent)
            }}>
              <ul style={styles.ul}>
                <li style={styles.li}>Payments for coaching or consulting services must be made in full as per agreed terms.</li>
                <li style={styles.li}>Refunds are not applicable unless explicitly stated for specific services.</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 4)}>
              <h3 style={styles.sectionH3}>5. Intellectual Property</h3>
              <span style={styles.chevron}>{expandedSections.terms[4] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[4] ? {} : styles.hiddenContent)
            }}>
              <p>
                All content on this website, including text, images, logos, videos, and graphics, is the property of Apex Advisors and may not be used without permission.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 5)}>
              <h3 style={styles.sectionH3}>6. Limitation of Liability</h3>
              <span style={styles.chevron}>{expandedSections.terms[5] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[5] ? {} : styles.hiddenContent)
            }}>
              <p>Apex Advisors is not responsible for:</p>
              <ul style={styles.ul}>
                <li style={styles.li}>University admissions or visa rejections</li>
                <li style={styles.li}>Changes in immigration policies or external regulations</li>
              </ul>
              <p style={styles.additionalInfo}>We guide to the best of our knowledge, but the final decision lies with the authorities.</p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 6)}>
              <h3 style={styles.sectionH3}>7. Modification of Terms</h3>
              <span style={styles.chevron}>{expandedSections.terms[6] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[6] ? {} : styles.hiddenContent)
            }}>
              <p>
                We reserve the right to update or modify these terms at any time. Continued use of the website after changes implies acceptance.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('terms', 7)}>
              <h3 style={styles.sectionH3}>8. Governing Law</h3>
              <span style={styles.chevron}>{expandedSections.terms[7] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.terms[7] ? {} : styles.hiddenContent)
            }}>
              <p>
                These terms shall be governed by and interpreted in accordance with the laws of Gujarat, India.
              </p>
            </div>
          </div>
        </div>

        {/* Privacy Policy */}
        <div style={{
          ...styles.tabContent,
          ...(activeTab === 'privacy' ? styles.activeContent : {})
        }}>
          <div style={styles.titleContainer}>
            <span style={styles.checkIcon}>✓</span>
            <h2 style={styles.contentH2}>Privacy Policy</h2>
          </div>
          <p style={styles.intro}>
            Apex Advisors values your privacy. This Privacy Policy explains how we collect, use, and protect your personal information.
          </p>
          
          {/* Privacy Sections */}
          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 0)}>
              <h3 style={styles.sectionH3}>1. Information We Collect</h3>
              <span style={styles.chevron}>{expandedSections.privacy[0] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[0] ? {} : styles.hiddenContent)
            }}>
              <p>We may collect the following:</p>
              <ul style={styles.ul}>
                <li style={styles.li}>Name, email, phone number</li>
                <li style={styles.li}>Academic records, test scores, and personal documents for admissions</li>
                <li style={styles.li}>Payment details (where applicable)</li>
                <li style={styles.li}>Information shared via contact forms or consultations</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 1)}>
              <h3 style={styles.sectionH3}>2. How We Use Your Information</h3>
              <span style={styles.chevron}>{expandedSections.privacy[1] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[1] ? {} : styles.hiddenContent)
            }}>
              <p>We use your data to:</p>
              <ul style={styles.ul}>
                <li style={styles.li}>Provide study abroad services and coaching</li>
                <li style={styles.li}>Assist with university admissions and visa applications</li>
                <li style={styles.li}>Send updates, offers, or important information</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 2)}>
              <h3 style={styles.sectionH3}>3. Sharing of Information</h3>
              <span style={styles.chevron}>{expandedSections.privacy[2] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[2] ? {} : styles.hiddenContent)
            }}>
              <p>We do not sell or rent your information. We may share data only with:</p>
              <ul style={styles.ul}>
                <li style={styles.li}>Partner universities or institutions (with your consent)</li>
                <li style={styles.li}>Visa consultants or officials when necessary</li>
                <li style={styles.li}>Legal authorities if required by law</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 3)}>
              <h3 style={styles.sectionH3}>4. Data Security</h3>
              <span style={styles.chevron}>{expandedSections.privacy[3] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[3] ? {} : styles.hiddenContent)
            }}>
              <p>
                We use industry-standard tools and practices to safeguard your information. However, no method is 100% secure.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 4)}>
              <h3 style={styles.sectionH3}>5. Cookies</h3>
              <span style={styles.chevron}>{expandedSections.privacy[4] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[4] ? {} : styles.hiddenContent)
            }}>
              <p>
                Our website may use cookies to improve user experience. You can disable cookies through your browser settings.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 5)}>
              <h3 style={styles.sectionH3}>6. Your Rights</h3>
              <span style={styles.chevron}>{expandedSections.privacy[5] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[5] ? {} : styles.hiddenContent)
            }}>
              <p>You have the right to:</p>
              <ul style={styles.ul}>
                <li style={styles.li}>Access, update, or delete your personal information</li>
                <li style={styles.li}>Withdraw consent for marketing at any time</li>
              </ul>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 6)}>
              <h3 style={styles.sectionH3}>7. Changes to this Policy</h3>
              <span style={styles.chevron}>{expandedSections.privacy[6] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[6] ? {} : styles.hiddenContent)
            }}>
              <p>
                We may update this policy periodically. Check this page for updates.
              </p>
            </div>
          </div>

          <div style={styles.section}>
            <div style={styles.sectionHeader} onClick={() => toggleSection('privacy', 7)}>
              <h3 style={styles.sectionH3}>8. Contact Us</h3>
              <span style={styles.chevron}>{expandedSections.privacy[7] ? '▼' : '►'}</span>
            </div>
            <div style={{
              ...styles.sectionContent,
              ...(expandedSections.privacy[7] ? {} : styles.hiddenContent)
            }}>
              <p>If you have questions, contact us at:</p>
              <div style={styles.contactInfo}>
                <p style={{...styles.contactInfoP, ...styles.companyName}}>Apex Advisors</p>
                <p style={styles.contactInfoP}>First Floor - 22, Rudra Complex,</p>
                <p style={styles.contactInfoP}>Next to Kalyan Jewelers, Ambawadi Bazar,</p>
                <p style={styles.contactInfoP}>Ambawadi, Ahmedabad, Gujarat – 380006</p>
                <p style={{...styles.contactInfoP, ...styles.email}}>📧 <a style={styles.contactInfoA} href="mailto:apexadvisorsindia@gmail.com">apexadvisorsindia@gmail.com</a></p>
                <p style={styles.contactInfoP}>📞 +91 82388 23767</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div style={styles.footer}>
        © 2025 Apex Advisors. All Rights Reserved.
      </div>
    </div>
  );
}

export default TermsAndConditions;
